// Copyright 2024 - MinIO, Inc. All rights reserved.

import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { fwRpc } from "../../../api";
import { setErrorSnackBarMessage, setSnackBarMessage } from "../../systemSlice";
import { loadGlobalSitesAsync } from "../../systemThunks";
import { FirewallRpcsAddFirewallBody } from "../../../api/firewallApi";

export const addFirewallAsync = createAsyncThunk(
  "firewall/addFirewallAsync",
  async (_, { getState, rejectWithValue, dispatch }) => {
    const state = getState() as RootState;

    const selectedSite = state.addFirewall.selectedSite;
    const name = state.addFirewall.name;
    const namespace = state.addFirewall.namespace;
    const configData = state.addFirewall.configData;
    const tenantReference = state.addFirewall.tenantReference;

    const request: FirewallRpcsAddFirewallBody = {
      name: name,
      namespace: namespace,
      configData: configData,
    };
    if (tenantReference) {
      request.tenantReference = tenantReference;
    }
    return fwRpc.api
      .addFirewall(selectedSite, request)
      .then((res) => {
        dispatch(setSnackBarMessage("Added Firewall Deployment successfully"));
        dispatch(loadGlobalSitesAsync());
        return res.data;
      })
      .catch((err) => {
        dispatch(setErrorSnackBarMessage(err.error));
        return rejectWithValue(err.error);
      });
  },
);
